import React, { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/signin/datacontroller/AuthContext';
import { PATH } from '@/main/controller/MainController';
import { isOnboardingCompleted } from '@/auth/signin/util/ProfileUtil';

type Pathname = (typeof PATH)[keyof typeof PATH];


const RequireAuthComp: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const { profile, isManualLogout } = useAuth();

  if (!profile) {
    const nextPath = isManualLogout ? PATH.LOGIN : `${PATH.LOGIN}?redirect=${encodeURIComponent(location.pathname)}`;
    return <Navigate to={nextPath} />;
  }

  if (
    !isOnboardingCompleted(profile) &&
    location.pathname.includes(PATH.MAIN) &&
    location.pathname !== PATH.ONBOARDING &&
    location.pathname !== PATH.AUTH_REDIRECT
  ) {
    return <Navigate to={PATH.ONBOARDING} />;
  }

  return <>{children}</>;
};

export default RequireAuthComp;
